if (!customElements.get('lazy-product-bundle')) {
  customElements.define(
    'lazy-product-bundle',
    class LazyProductBundle extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.template = this.querySelector('template');
        if (!this.template) return;

        if (this.dataset.designMode === 'true') {
          this.hydrate();
          return;
        }

        const observe = () => {
          if (!this.isConnected) return;
          if (!('IntersectionObserver' in window)) {
            this.hydrate();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.hydrate();
            },
            { rootMargin: '400px 0px' },
          );
          this.observer.observe(this);
        };

        if (document.readyState === 'complete') {
          this.schedule(observe);
        } else {
          window.addEventListener('load', () => this.schedule(observe), { once: true });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      schedule(callback) {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(callback, { timeout: 2000 });
        } else {
          window.setTimeout(callback, 200);
        }
      }

      hydrate() {
        if (!this.template || this.dataset.hydrated === 'true') return;
        this.dataset.hydrated = 'true';
        this.observer?.disconnect();

        const scriptSource = this.dataset.scriptSource;
        const styleSource = this.dataset.styleSource;
        Promise.all([this.loadStyle(styleSource), this.loadScript(scriptSource)]).then(() => {
          if (!this.isConnected || !this.template) return;
          this.template.replaceWith(this.template.content.cloneNode(true));
          this.template = null;
        });
      }

      loadStyle(source) {
        if (!source) return Promise.resolve();
        window.llProductBundleStylePromise ??= new Promise((resolve, reject) => {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = source;
          stylesheet.onload = resolve;
          stylesheet.onerror = reject;
          document.head.append(stylesheet);
        });
        return window.llProductBundleStylePromise;
      }

      loadScript(source) {
        if (!source || customElements.get('product-bundle')) return Promise.resolve();
        window.llProductBundleScriptPromise ??= new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = source;
          script.async = true;
          script.fetchPriority = 'low';
          script.onload = resolve;
          script.onerror = reject;
          document.head.append(script);
        });
        return window.llProductBundleScriptPromise;
      }
    },
  );
}
